module.exports = __webpack_public_path__ + "static/media/icon_protection.e9917a29.svg";